import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import toast from '../shared/Toast';
import { receiptService } from '../../_services';

class SendReceiptModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: props.clientEmail || '',
            emailError: '',
            isSubmitting: false
        };
    }

    componentDidUpdate(prevProps) {
        // Update email if clientEmail prop changes
        if (prevProps.clientEmail !== this.props.clientEmail) {
            this.setState({ email: this.props.clientEmail || '' });
        }
    }

    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value,
            emailError: ''
        });
    }

    validateEmail = (email) => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    handleSubmit = (e) => {
        e.preventDefault();
        
        const { email } = this.state;
        const { bookingId } = this.props;
        
        // Validate email
        if (!email) {
            this.setState({ emailError: 'Email is required' });
            return;
        }
        
        if (!this.validateEmail(email)) {
            this.setState({ emailError: 'Please enter a valid email address' });
            return;
        }
        
        this.setState({ isSubmitting: true });
        
        // Send receipt email
        receiptService.sendReceiptEmail({ bookingId, email })
            .then(response => {
                this.setState({ isSubmitting: false });
                if (response.data && response.data.statusCode === 1) {
                    toast.success('Receipt sent successfully');
                    this.props.onClose();
                } else {
                    toast.error(response.data?.message || 'Failed to send receipt');
                }
            })
            .catch(error => {
                this.setState({ isSubmitting: false });
                toast.error(error.response?.data?.message || 'Failed to send receipt');
            });
    }

    render() {
        const { email, emailError, isSubmitting } = this.state;
        
        return (
            <Modal
                show={true}
                onHide={this.props.onClose}
                backdrop={true}
                keyboard={true}
                centered
                size="lg"
                dialogClassName="reception-mode-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Send Receipt</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="mb-4">Enter the email address to send the receipt to.</p>
                    <form onSubmit={this.handleSubmit}>
                        <h3 className="mb-3" style={{ fontSize: '24px', fontWeight: 'bold', color: '#29282E' }}>Email Address</h3>
                        <div className="mb-5">
                            <input
                                type="email"
                                className={`form-control reception-mode-input ${emailError ? 'is-invalid' : ''}`}
                                id="email"
                                value={email}
                                onChange={this.handleChange}
                                placeholder="Enter email address"
                                disabled={isSubmitting}
                                style={{
                                    height: '80px',
                                    borderRadius: '9px',
                                    fontSize: '18px',
                                    border: '1px solid #707070'
                                }}
                            />
                            {emailError && <div className="invalid-feedback">{emailError}</div>}
                        </div>
                        <div className="d-flex justify-content-end">
                            <button
                                type="submit"
                                className="btn reception-mode-button"
                                disabled={isSubmitting}
                                style={{
                                    backgroundColor: '#007EA0',
                                    color: 'white',
                                    height: '60px',
                                    width: '280px',
                                    borderRadius: '9px',
                                    fontSize: '18px',
                                    fontWeight: 'bold'
                                }}
                            >
                                {isSubmitting ? 'Sending...' : 'Send Email'}
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        );
    }
}

export default SendReceiptModal;